import { flow, forEach } from 'lodash';
import { addClass, removeClass, setAttribute } from 'app/utils/domHelpers';

const nrOfDots = ({ innerElements, slidesToScroll = 1 }) => Math.ceil(innerElements.length / slidesToScroll);
const nrOfActiveDot = carousel =>
  Math.ceil(nrOfDots(carousel) / (carousel.innerElements.length / carousel.currentSlide));

const createDotItem = ({ innerElements, goTo, slidesToScroll = 1 }, index) => {
  const dotItem = flow([
    document.createElement.bind(document),
    addClass('dot'),
    setAttribute('role', 'tab'),
    setAttribute('tabindex', '0'),
    setAttribute('aria-selected', 'false'),
    setAttribute('aria-describedby', innerElements[index * slidesToScroll].id),
  ])('li');
  const clickCallback = () => goTo(index * slidesToScroll);
  dotItem.addEventListener('click', clickCallback);
  dotItem.addEventListener('keyup', ({ which }) => which === 13 && clickCallback());
  return dotItem;
};

const createDotsList = carousel => {
  const ul = flow([document.createElement.bind(document), addClass('carousel-dots'), setAttribute('role', 'tablist')])(
    'ul'
  );
  for (let i = 0; i < nrOfDots(carousel); i++) {
    ul.appendChild(createDotItem(carousel, i));
  }
  return ul;
};

const handleDotsKeyEvents = ({ which, shiftKey }, dots) => {
  const activeDotIndex = [...dots].indexOf(document.activeElement);
  let nextActiveDot;
  const leftArrow = 37;
  const rightArrow = 39;
  const tab = 9;

  switch (which) {
    case tab:
      if (shiftKey) {
        dots[0].focus();
      } else {
        dots[dots.length - 1].focus();
      }
      break;
    case leftArrow:
      nextActiveDot = activeDotIndex ? activeDotIndex - 1 : dots.length - 1;
      dots[nextActiveDot].focus();
      break;
    case rightArrow:
      nextActiveDot = activeDotIndex === dots.length - 1 ? 0 : activeDotIndex + 1;
      dots[nextActiveDot].focus();
      break;
    default:
      break;
  }
};

const setActiveDot = (dots, activeDotIndex) => {
  forEach(dots, flow([removeClass('active'), setAttribute('aria-selected', 'false')]));
  flow([addClass('active'), setAttribute('aria-selected', 'true')])(dots[activeDotIndex]);
};

export const createCarouselDots = carousel => {
  const ul = createDotsList(carousel);
  setActiveDot(ul.children, 0);
  carousel.selector.addEventListener('change', () => {
    setActiveDot(ul.children, nrOfActiveDot(carousel));
  });
  ul.addEventListener('keydown', e => {
    handleDotsKeyEvents(e, ul.children);
  });
  return ul;
};
